module.exports = __webpack_public_path__ + "static/nick-0160724d90ccf6a51e6017b533385f13.png";